<template>
  <div class="mx-auto w-full md:pt-20">
    <div class="text-center">
      <graphic-base height="116" width="116" viewBox="0 0 116 116">
        <checked-circle />
      </graphic-base>
    </div>
    <div class="mt-4">
      <p class="custom-color-neutral text-zt-lg text-center">{{ $t('message.LicensesSolicitudeComponent.modals.solicitudeOk') }}</p>
    </div>
    <div class="mt-40 md:bottom-auto md:relative">
      <div class="w-full mx-auto text-center">
        <zt-button @click="$emit('ok-request')" class="w-6/12 button-shadow" data-vs-button="continue">
          {{ $t('message.LicensesSolicitudeComponent.modals.continue') }}
        </zt-button>
      </div>
    </div>
  </div>
</template>

<script>
import graphicBase from '@/components/commons/Illustrations/graphicBase'
import checkedCircle from '@/components/commons/Illustrations/graphicSVG/CheckedCircleSVG'

export default {
  components: {
    graphicBase,
    checkedCircle
  }
}
</script>